import { Banner } from '@time-line/components/blocks';
import { PageTitle } from '@time-line/components/common';
import { PageModuleResolver } from 'components/common/PageModuleResolver';
import { PageWrapper } from 'components/common/PageWrapper';
import { Seo } from 'components/common/Seo';
import { useTestimonials } from 'hooks/pages/useTestimonials';
import { useRatingsOverview } from 'hooks/reviews/useRatingsOverview';
import { addReviewsToOverline } from 'utils/addReviewsToOverline';

export function Testimonials() {
  const { data: testimonials } = useTestimonials();
  const { data: ratingsOverview } = useRatingsOverview();

  const { overline, ...restOfBanner } = testimonials.banner;
  const bannerOverline = overline
    ? addReviewsToOverline(overline, ratingsOverview)
    : undefined;

  return (
    <PageWrapper as="main">
      <Seo seo={testimonials.seo} />
      <PageTitle title={testimonials.title} />
      <PageModuleResolver
        blocks={testimonials.blocks}
        pageTitle="Testimonials"
      />
      <Banner {...restOfBanner} overline={bannerOverline} />
    </PageWrapper>
  );
}
